import { Card } from "@mui/material";
import { Question, Questionnaire } from "./models";
import { QuestionView } from "./QuestionView";
import React from "react";
import './QuestionsView.css';

export const QuestionsView = ({questions, questionnaire, onChange, showInCard} : { questions : Question[], questionnaire: Questionnaire, onChange: (questions: Question[]) => void, showInCard?: boolean }) => {

  const handleOnChange = (question: Question) => {
    const updatedQuestions = questions.map((item) => {
      if (item.key === question.key) {
        return question;
      }

      return item;
    });

    console.log('updatedQuestions', updatedQuestions);
    onChange(updatedQuestions);
  };

  console.log('QuestionsView', questions);

  const satisfiesCondition = (question: Question) => question.condition ? question.condition(questionnaire) : true;

  return (
    <div>
      {questions.map((question, index) => (
        <div key={index} className={question.className}>
          {satisfiesCondition(question) && (
            <>
              {showInCard ? (
                <Card style={{padding: '1rem', marginBottom: '1rem'}}>
                  <QuestionView question={question} questionnaire={questionnaire} onChange={handleOnChange} />
                </Card>
              ) : (
                <QuestionView question={question} questionnaire={questionnaire} onChange={handleOnChange} />
              )}
            </>
          )}
        </div>
      ))}
    </div>
  );
};
